import { Button, Container, Nav, Navbar } from 'react-bootstrap';

const Header = () => {
    const currentPath = window.location.pathname;

    const isActive = (path) => {
        if (path === '/') {
            return currentPath === '/';
        }

        return currentPath === path || currentPath.startsWith(`${path}/`);
    };

    return (
        <Navbar expand="lg" fixed="top" className="site-header" variant="dark">
            <Container>
                <Navbar.Brand href="/" className="brand-mark">
                    <img src="/myLogo.svg" alt="SalesFractionPro" className="brand-logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="primary-nav" />
                <Navbar.Collapse id="primary-nav">
                    <Nav className="ms-auto align-items-lg-center gap-lg-3">
                        <Nav.Link href="/" active={isActive('/')} aria-current={isActive('/') ? 'page' : undefined}>
                            Home
                        </Nav.Link>
                        <Nav.Link href="/about" active={isActive('/about')} aria-current={isActive('/about') ? 'page' : undefined}>
                            About
                        </Nav.Link>
                        <Nav.Link href="/services" active={isActive('/services')} aria-current={isActive('/services') ? 'page' : undefined}>
                            Services
                        </Nav.Link>
                        <Nav.Link href="/contact" active={isActive('/contact')} aria-current={isActive('/contact') ? 'page' : undefined}>
                            Contact
                        </Nav.Link>
                        <Button as="a" href="/book-a-free-consultation" variant="primary" className="header-cta">
                            Book a Free Consultation
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
